export class Error {
    Message: string = null;
    status: string = null;
    statusText: string = null;
    ok: boolean = false;

    constructor() { }
}
